// extracted by mini-css-extract-plugin
export default {"toggleBox":"Toggle_toggleBox__5PAf1","toggle":"Toggle_toggle__enGld","active":"Toggle_active__DkNDs"};